import { useEffect, useMemo, useCallback, useRef, useState } from "react";
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  Tab,
  Tabs,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  useTheme, useMediaQuery,
  IconButton
} from "@mui/material";
import { PROCTORING_TYPE } from "../../config/appConfig";
import checkAuth from "../../common/CheckAuth";
import InfoIcon from "@mui/icons-material/Info";
import PrimaryButton from "../../common/primaryButton";
import SecondaryButton from "../../common/secondaryButton";
import { BsArrowsFullscreen } from "react-icons/bs";
import QuestionNumberComponent from "./QuestionNumbersComponent";
import CalculatorComponent from "./CalculatorComponent";
import { useNavigate, useSearchParams } from "react-router-dom";
import commonActions from "../../Redux/common/actions";
import { useDispatch, useSelector } from "react-redux";
import SubmitModal from "./submitModal";
import ZoomModal from "./zoomModal";
import FilePreviewModal from "./filePreviewModal";
import InstructionModal from "./instructionModal";
import Cookies from "js-cookie";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import examActions from "../../Redux/exam/actions";
import {
  DecryptObjectFunction,
  EncryptObjectFunction,
} from "../../utils/cryptoFunction";
import dayjs from "dayjs";
import useFetchQuestion from "../../hooks/useFetchQuestion";
import useFetchCandidateTokenDetails from "../../hooks/useFetchCandidateTokenDetails";
import WatermarkBackground from "../../common/watermark";
import logImage from "../../assets/images/log.png";
import { GoPaperclip } from "react-icons/go";
import { MdOutlineDataThresholding } from "react-icons/md";
import { LuTable } from "react-icons/lu";
import ToolBarModal from "./toolBarModal";
import { auditLog } from "../../utils/auditLog";
import { AiOutlineLeftCircle, AiOutlineRightCircle } from "react-icons/ai";
import { AiFillRightCircle } from "react-icons/ai";
import Chatbot from "./Chatbot";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { toast } from "react-toastify";
import { Warning } from "@mui/icons-material";
import { duration } from "moment/moment";
import { ensureFullscreen } from "../../utils/fullScreenHelper";
import { IoMdCloseCircleOutline } from "react-icons/io";
import usePreventBackNavigation from "../../hooks/usePreventBackNavigation";
import PreventBackNavigationWarningModal from "./preventBackNavigationWarningModal";
import AnswerSection from "./AnswerSection";
import debounce from "lodash/debounce";

export default function Index() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    !window.MSStream;

  // State declarations
  const questionScrollRef = useRef(null);
  const answerScrollRef = useRef(null);
  const togglePanelRef = useRef(null);
  const lastValueRef = useRef("");
  const editorInstanceRef = useRef(null);

  const [uploadStates, setUploadStates] = useState({});
  const [showBackWarning, setShowBackWarning] = useState(false);
  const [visibilityDialogOpen, setVisibilityDialogOpen] = useState(false);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [inactivePopup, setInactivePopup] = useState(false);
  const [decryptedParams, setDecryptedParams] = useState({});
  const [nextQuestion, setNextQuestion] = useState([]);
  const [cachedImage, setCachedImage] = useState("");
  const [currentSectionIndex, setCurrentSectionIndex] = useState(-1);
  const [nextQsInFilter, setNextQsInFilter] = useState(null);
  const [previousQsInFilter, setPreviousQsInFilter] = useState(null);
  const [currentQuestionStatus, setCurrentQuestionStatus] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(isMobile ? 250 : 100);
  const [selectedLanguage, setSelectedlanguage] = useState(null);
  const [markedValue, setMarkedValue] = useState(0);
  const [value, setValue] = useState(1);
  const [currentSectionTitle, setCurrentSectionTitle] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [selectedValue, setSelectedValue] = useState(0);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [isFirstQuestion, setIsFirstQuestion] = useState(false);
  const [isLastQuestion, setIsLastQuestion] = useState(false);
  const [isSectionLastQuestion, setIsSectionLastQuestion] = useState(false);
  const [activeSection, setActiveSection] = useState(0);
  const [action, setAction] = useState("");
  const [close, setClose] = useState(false)
  const [remainingTime, setRemainingTime] = useState(() => {
    return Number(localStorage.getItem("remainingTime")) || 0;
  });
  const currentAction = localStorage.getItem('currentAction');
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
    totalMinutes: 0,
  });
  const inactivityTimer = useRef(null);
  const lastApiCallTime = useRef(0);
  const logoutTimer = useRef(null);
  const debouncedSaveRef = useRef(null);
  const currentStatusRef = useRef(null);
  const imageSizeRef = useRef(null);
  const languageRef = useRef(null);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const { questionsAndOptions, heartBeat, projectDetails, instructions, inlineUploadUrls } =
    useSelector((state) => state.examReducer);

  const [isAnswerOptionPopupOpen, setIsAnswerOptionPopupOpen] = useState(false);
  const [selectedZoomInValue, setSelectedZoomInValue] = useState('100%');
  const [zoomScale, setZoomScale] = useState(1.5);

  // Derieved variables
  const apiTimeout = 980 * 60 * 1000;
  const idleTimeout = 30 * 1000;
  const apiInterval = 30 * 1000;
  const isVenue = sessionStorage.getItem("venue") ?? false;
  const apiUrl = sessionStorage.getItem("apiUrl");
  const examEndTime = localStorage.getItem("examEndTime");
  const examEndDate = new Date(examEndTime);
  examEndDate.setTime(examEndDate.getTime() + (5 * 60 + 30) * 60 * 1000);
  const isMock = projectDetails?.mockMode;
  const updatedExamEndTime = isMock
    ? candidateTokenDetails?.configuration?.endTime
    : examEndDate.toISOString();
  const isLateLoginAllowed =
    candidateTokenDetails?.configuration?.lateLoginAllowed;
  const encryptedParams = searchParams.get("qNo");
  const imageSize = decryptedParams?.img ?? "L";
  const language = decryptedParams?.lang || "english";
  const currentSrNo = decryptedParams?.SrNo;
  const [visitedQuestions, setVisitedQuestions] = useState(new Set());
  const isCalculator = candidateTokenDetails?.configuration?.calculator;
  const candidateData = JSON.parse(sessionStorage.getItem("candidate_details"));
  const candidateInfoData = JSON.parse(sessionStorage.getItem("candidateInfo"));
  const sectionLength = candidateTokenDetails?.configuration?.sections?.length;
  const tabIndex = JSON.parse(tabValue)?.index + 1;
  const rollNo = candidateTokenDetails?.user?.rollNo;
  const dob = candidateTokenDetails?.user?.dob;
  const queryParams = {
    SrNo: currentSrNo,
    lang: `${language}`,
    img: `${imageSize}`,
    action: `${action}` || currentAction,
  };
  const encryptedParamsConverted = EncryptObjectFunction(queryParams);
  const timeUp =
    heartBeat?.data > candidateTokenDetails?.configuration?.endTime;
  const submitButtonDisplayMinutes =
    candidateTokenDetails?.configuration?.submitButtonDisplayMinutes;
  const questionLength = questionsAndOptions?.questionsList
    ? Object.keys(questionsAndOptions.questionsList).length
    : 0;
  const isSection = Object.values(
    questionsAndOptions?.questionsList || {}
  ).every((res) => "section" in res);
  const filteredInstructions = instructions?.instructions?.filter(
    (instruction) => instruction.language === selectedLanguage
  );
  const isStartExamBetweenSpecifiedTime =
    candidateTokenDetails?.configuration?.startExamBetweenSpecifiedTime;
  const isMultidayExamWithSection =
    isSection && isStartExamBetweenSpecifiedTime;
  const now = dayjs(heartBeat?.data);
  const startTime = dayjs(candidateTokenDetails?.configuration?.startTime);
  const diffInSeconds = now.diff(startTime, "second");
  const sections =
    isSection && candidateTokenDetails
      ? candidateTokenDetails?.configuration?.sections
      : [];
  const pvCharts = candidateTokenDetails?.configuration?.pvCharts;
  const heatTable = candidateTokenDetails?.configuration?.heatTable;
  const helpDocument = candidateTokenDetails?.configuration?.helpDocument;
  const logTables = candidateTokenDetails?.configuration?.logTables;
  const isAutologout = candidateTokenDetails?.configuration?.autoLogout;

  ///////// proctoring method///////
  const proctoringEnabled =
  candidateTokenDetails?.configuration?.proctoringEnabled === true;
  const proctoringType =
  candidateTokenDetails?.configuration?.proctoringType || null;
  const proctoringEngine =
  candidateTokenDetails?.configuration?.proctoringEngine || null;
  const violations =
  candidateTokenDetails?.configuration?.violations || null;
  const violationThresholdCount = candidateTokenDetails?.configuration?.violationThresholdCount || null;
  const isViolationAutoSubmitEnabled = candidateTokenDetails?.configuration?.isViolationAutoSubmitEnabled || false;
  ////////////////////////////////

  // const dispatch = useDispatch();
  const examEvents = useSelector(state => state.examReducer.examEvents); //Broadcast events

  const isNoMovementTimeRestriction =
    candidateTokenDetails?.configuration?.sectionNavigation ==
    "NO_MOVEMENT_OR_TIME_RESTRICTION";
  const isQuestionNavigationForwardOnly =
    candidateTokenDetails?.configuration?.questionNavigationForwardOnly;
  const isFixedTimeMovementRestriction =
    candidateTokenDetails?.configuration?.sectionNavigation ==
    "FIXED_TIME_AND_MOVEMENT_RESTRICTION";
  const isMovementRestrictionWithIncrementalTime =
    candidateTokenDetails?.configuration?.sectionNavigation ==
    "MOVEMENT_RESTRICTION_WITH_INCREMENTAL_TIME";
  const isMovementRestrictionWithNoTimeRestriction =
    candidateTokenDetails?.configuration?.sectionNavigation ==
    "MOVEMENT_RESTRICTION_WITH_NO_TIME";
  const examRef = useRef(null);
  const chatRef = useRef(null);
  const clientid = String(candidateInfoData?.clientid || candidateInfoData?.examclientid || '');
  const candidateid = String(candidateInfoData?.id || '');
  const examid = String(candidateInfoData?.examid || '');



  ////////// REAL-TIME EVENT HANDLER + LOCALSTORAGE DEDUPLICATION //////////

  //////////// REAL-TIME EVENT HANDLING + LOCALSTORAGE DEDUP ////////////

  const dispatch = useDispatch();
  const broadcastEvents = useSelector(state => state.examReducer.examEvents);

  // Map backend code → local handler
  const eventCodeMap = {
    "REFRESH": "refresh",
    "WARNING": "alert",
    "ERROR": "alert"

  };

  // LocalStorage helpers
  const storage = {
    get: (key) => JSON.parse(localStorage.getItem(key)) || [],
    set: (key, val) => localStorage.setItem(key, JSON.stringify(val)),
  };

  // Browser helpers
  const navigatorHelper = {
    reload: () => window.location.reload(),
    redirect: (path) => (window.location.href = path),
    alert: (msg) => alert(msg),
  };

  // Store processed event ID
  const markProcessed = (id) => {
    const processed = storage.get("processedEvents");
    if (!processed.includes(id)) {
      processed.push(id);
      storage.set("processedEvents", processed);
    }
  };

  const toMs = (seconds, fallbackMs = 2500) => {
    const n = Number(seconds);
    if (!Number.isFinite(n) || n <= 0) return fallbackMs;
    return Math.round(n * 1000);
  };

  // Handlers
  const actionHandlers = {
    refresh: (event) => {
      navigatorHelper.reload();
    },


    alert: (event) => {
      const status = event?.type === 'ERROR' ? 'failed' : 'alert';
      const message = event?.description || event?.message || 'Attention required';

      const durationMs = toMs(
        event?.durationSeconds ?? event?.duration ?? event?.ttl,
        2500 // default if missing/invalid
      );

      dispatch({
        type: commonActions.SET_ALERT,
        payload: { show: true, status, message },
      });

      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: { show: false, status: null, message: null },
        });
      }, durationMs);
    },

  };

  //////////// POLLING EVERY 10 SEC ////////////

  useEffect(() => {
    dispatch({ type: examActions.GET_EXAM_EVENTS });

    const intervalId = setInterval(() => {
      console.log("Polling for broadcast events...");
      dispatch({ type: examActions.GET_EXAM_EVENTS });
    }, 10 * 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setZoomLevel(190);
      setClose(true); // mobile readable size
    } else {
      setZoomLevel(100);
      setClose(false);// desktop untouched
    }
  }, [isMobile]);


  //////////// PROCESS EVENTS ONLY IF NEW ////////////

  useEffect(() => {
    if (!broadcastEvents || broadcastEvents.length === 0) return;

    broadcastEvents.forEach(event => {
      const processed = storage.get("processedEvents");

      // Skip already processed event
      if (processed.includes(event.id)) return;

      // Find mapped action
      const mappedAction = eventCodeMap[event.type];
      if (!mappedAction) return;

      // Fire handler FIRST
      actionHandlers[mappedAction]({
        id: event.id,
        type: event.type,
        code: event.code,
        description: event.description,
        duration: event.duration
      });

      // Store AFTER successful handler
      markProcessed(event.id);
    });

  }, [broadcastEvents]);


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    if (!checkAuth(navigate)) return;
  }, []);

  usePreventBackNavigation(setShowBackWarning);

  useEffect(() => {
    if (!examRef.current) return;

    const onCompleted = (e) => {
      console.log('Completed', e.detail);
      dispatch({ type: examActions.END_EXAM, payload: { mockMode: false } });
      navigate('/thank-you');
    };
    const onPaused   = (e) => console.log('Paused', e.detail);
    const onResumed  = (e) => console.log('Resumed', e.detail);
    const onError    = (e) => console.error('Error', e.detail);

    examRef.current.addEventListener('examCompleted', onCompleted);
    examRef.current.addEventListener('examPaused',    onPaused);
    examRef.current.addEventListener('examResumed',   onResumed);
    examRef.current.addEventListener('examError',     onError);

    return () => {
      examRef.current?.removeEventListener('examCompleted', onCompleted);
      examRef.current?.removeEventListener('examPaused',    onPaused);
      examRef.current?.removeEventListener('examResumed',   onResumed);
      examRef.current?.removeEventListener('examError',     onError);
    };
  }, [encryptedParams, proctoringEnabled]);

  // Side effects
  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  useFetchQuestion({
    currentSrNo,
    language,
    imageSize,
    questionsAndOptions,
    decryptedParams,
    projectDetails,
    handleEncodeJson,
    EncryptObjectFunction,
    isNavigate: true,
  });

  // ✅ Prevent tab flicker when section manually changed
  useEffect(() => {
    if (!questionsAndOptions?.questionsList || !currentSrNo) return;
    if (!candidateTokenDetails?.configuration?.sections) return;

    const obj = questionsAndOptions.questionsList;
    const arr = Object.entries(obj).map(([key, val]) => ({
      qNo: key,
      ...val,
    }));

    const currentQuestion = arr.find((i) => i.qNo == currentSrNo);
    if (!currentQuestion) return;

    const sectionTitle = currentQuestion.section;
    const index = candidateTokenDetails.configuration.sections.findIndex(
      (section) => section.sectionTitle === sectionTitle
    );

    // ✅ Always update to current section based on question
    // This ensures tab updates when auto-advancing to new section
    setCurrentSectionTitle(sectionTitle);
    setTabValue(JSON.stringify({ index, sectionTitle }));    
  }, [
    questionsAndOptions?.questionsList,
    currentSrNo,
    candidateTokenDetails?.configuration?.sections,
  ]);

  useEffect(() => {
    if (!isMobile || close) return;

    const handleOutsideClick = (event) => {
      if (
        togglePanelRef.current &&
        !togglePanelRef.current.contains(event.target)
      ) {
        setClose(true);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [close, isMobile]);

  // useEffect(() => {
  //   if (questionsAndOptions?.questionsList && currentSrNo) {
  //     const obj = questionsAndOptions?.questionsList;
  //     const arr = Object.entries(obj).map(([key, val]) => ({
  //       qNo: key,
  //       ...val,
  //     }));
  //     let firstSectionTitle = arr[0]?.section;
  //     setCurrentSectionTitle(currentSectionTitle || firstSectionTitle);
  //     const currentSection = arr.find((i) => i?.qNo == currentSrNo);
  //     const index = candidateTokenDetails?.configuration?.sections.findIndex(
  //       (section) => section.sectionTitle === currentSection.section
  //     );
  //     if (currentSectionTitle) {
  //       setTabValue(
  //         JSON.stringify({
  //           index,
  //           sectionTitle: currentSectionTitle || firstSectionTitle,
  //         })
  //       );
  //     } else {
  //       setTabValue(
  //         JSON.stringify({
  //           index: 0,
  //           sectionTitle: currentSectionTitle || firstSectionTitle,
  //         })
  //       );
  //     }

  //     if (currentSection) {
  //       const index = candidateTokenDetails?.configuration?.sections.findIndex(
  //         (section) => section.sectionTitle === currentSection.section
  //       );
  //       const sectionTitle =
  //         index !== -1
  //           ? candidateTokenDetails.configuration.sections[index].sectionTitle
  //           : null;
  //       setCurrentSectionTitle(sectionTitle);
  //       if (index !== -1) {
  //         setTabValue(
  //           JSON.stringify({ index, sectionTitle: currentSection.section })
  //         );
  //       }
  //     }
  //   }
  // }, [
  //   questionsAndOptions?.questionsList,
  //   currentSrNo,
  //   candidateTokenDetails?.configuration?.sections,
  //   heartBeat,
  // ]);

  useEffect(() => {
    // Scroll both containers to top
    if (questionScrollRef.current) {
      questionScrollRef.current.scrollTo({ top: 0, left:0, behavior: "smooth" });
    }
    if (answerScrollRef.current) {
      answerScrollRef.current.scrollTo({ top: 0, left:0,behavior: "smooth" });
    }
  }, [currentSrNo]); //left:0 bhi add kar do

  // useEffect(() => {
  //   const cleanup = setupFullscreenBlock();
  //   if (!document.fullscreenElement) {
  //     document.documentElement.requestFullscreen().catch((err) => {
  //       console.warn("Failed to enter fullscreen:", err);
  //     });
  //   }
  //   return () => {
  //     cleanup();
  //   };
  // }, []);

  //   useEffect(() => {
  //   setupFullscreenBlock();
  //   requestFullscreenSafe(); // ✅ iOS safe
  // }, []);

  useEffect(() => {
    dispatch({
      type: examActions.GET_PROJECT_DETAILS,
      payload: {
        data: {
          project: `${Cookies.get("test_engine_project")}`,
        },
      },
    });
  }, []);

  useEffect(() => {
    if (encryptedParams) {
      let decrypted = DecryptObjectFunction(encryptedParams);
      setDecryptedParams(decrypted);
    } else {
      navigate(`/${Cookies.get("test_engine_project")}/home`);
    }
  }, [encryptedParams]);

  useEffect(() => {
    const questionData = questionsAndOptions?.questionData;

    if (!questionData) return;

    if (!questionData.srNo) return;

    if (String(questionData.srNo) !== String(currentSrNo)) return;

    if (questionData.questionType === "DESCRIPTIVE_TYPING") {
      const cached = sessionStorage.getItem(`descriptive_answer_${currentSrNo}`);
      const dbValue = questionData.descriptiveTypingAnswer;

      const value =
        dbValue !== undefined && dbValue !== null
          ? dbValue
          : cached || "";

      lastValueRef.current = value;
      setSelectedValue(value);
    }

    if (questionData.questionType === "MCQ") {
      const selected = questionData.selectedAnswer ?? 0;
      setSelectedValue(selected || 0);
    }

    if (questionData.questionType === "DESCRIPTIVE_UPLOAD") {
      const srNoKey = String(currentSrNo);
      const sessionActed = srNoKey in (inlineUploadUrls ?? {});
      const ansUrl = sessionActed
        ? inlineUploadUrls[srNoKey]
        : questionData.descriptiveUploadAnsUrl;

      if (ansUrl) {
        setUploadStates((prev) => {
          if (prev[currentSrNo]?.status === "success") return prev;
          const pathWithoutQuery = ansUrl.split("?")[0];
          const lastSegment = pathWithoutQuery.split("/").pop() ?? "";
          const prefixPattern = new RegExp(`^srNo-${currentSrNo}-\\d+-`);
          const name =
            decodeURIComponent(lastSegment.replace(prefixPattern, "")) ||
            `Q${currentSrNo}_answer`;
          return {
            ...prev,
            [currentSrNo]: {
              file: { name, size: 0, _isExisting: true, _path: ansUrl },
              status: "success",
              fileUrl: ansUrl,
              error: null,
            },
          };
        });
      } else if (sessionActed) {
        // User explicitly deleted in this session — clear any stale local state
        setUploadStates((prev) => {
          if (!prev[currentSrNo]) return prev;
          const next = { ...prev };
          delete next[currentSrNo];
          return next;
        });
      }
    }

  }, [questionsAndOptions, currentSrNo, inlineUploadUrls]);

  useEffect(() => {
    if (questionsAndOptions?.questionsList && currentSrNo) {
      const questionData = questionsAndOptions.questionsList[currentSrNo];
      setMarkedValue(
        questionData?.status === "MARKED" ||
          questionData?.status === "ANSWERED_AND_MARKED"
          ? true
          : false
      );
      setCurrentStatus(questionData?.status?.toLowerCase());
    } else {
      setMarkedValue(null);
    }
  }, [questionsAndOptions, currentSrNo]);

  useEffect(() => {
    if (instructions?.instructions && instructions?.instructions[0]?.language)
      setSelectedlanguage(language || instructions?.instructions[0]?.language);
  }, [instructions?.instructions]);

  useEffect(() => {
    let nextqs =
      nextQuestion[
        nextQuestion.findIndex(
          (obj) => parseInt(obj.question_number) === currentSrNo
        ) + 1
      ]?.question_number;

    setNextQsInFilter(nextqs);
  }, [
    questionsAndOptions,
    currentSrNo,
    language,
    imageSize,
    questionsAndOptions?.questionData?.srNo,
    decryptedParams,
  ]);

  useEffect(() => {
    if (nextQuestion) {
      let prevqs =
        nextQuestion[
          nextQuestion.findIndex(
            (obj) => parseInt(obj.question_number) === currentSrNo
          ) - 1
        ]?.question_number;
      setPreviousQsInFilter(prevqs);
    }
  }, [
    questionsAndOptions,
    currentSrNo,
    language,
    imageSize,
    questionsAndOptions?.questionData?.srNo,
    decryptedParams,
    previousQsInFilter,
  ]);

  useEffect(() => {
    const storedVisited = sessionStorage.getItem("visitedQuestions");
    if (storedVisited) {
      setVisitedQuestions(new Set(JSON.parse(storedVisited)));
    }
    if (currentSrNo) {
      setVisitedQuestions((prev) => new Set([...prev, currentSrNo.toString()]));
      sessionStorage.setItem(
        "visitedQuestions",
        JSON.stringify([
          ...new Set([...visitedQuestions, currentSrNo.toString()]),
        ])
      );
    }
  }, [currentSrNo]);

  useEffect(() => {
    if (
      questionsAndOptions &&
      questionsAndOptions.questionsList &&
      currentSrNo
    ) {
      function getQuestionStatus(data, currentSrNo) {
        const questionData = data[currentSrNo];
        return questionData ? questionData?.status : null;
      }
      const currentQuestionStatus = getQuestionStatus(
        questionsAndOptions?.questionsList,
        currentSrNo
      );
      setCurrentQuestionStatus(currentQuestionStatus);
    }
  }, [
    questionsAndOptions,
    currentSrNo,
    decryptedParams,
    currentSrNo,
    language,
    imageSize,
    questionsAndOptions?.questionData?.srNo,
  ]);

  useEffect(() => {
    const startTime = Date.parse(
      candidateTokenDetails?.configuration?.startTime
    );
    const endTime =
      // isLateLoginAllowed || isMultidayExamWithSection
      //   ? Date.parse(candidateTokenDetails?.configuration?.endTime)
      //   : Date.parse(
      //       updatedExamEndTime ?? candidateTokenDetails?.configuration?.endTime
      //     );
      Date.parse(
        updatedExamEndTime ?? candidateTokenDetails?.configuration?.endTime
      );
    const updateTimer = () => {
      const now = new Date(heartBeat?.data);

      if (now < startTime) {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      if (now > endTime) {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const difference = endTime - now;

      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const totalSeconds = Math.floor(difference / 1000);
      const seconds = totalSeconds % 60;
      const totalMinutes = Math.floor(difference / (1000 * 60));
      setTimeLeft({ hours, minutes, seconds, totalMinutes });
    };

    updateTimer();
    const interval = setInterval(updateTimer, 60000);
    return () => clearInterval(interval);
  }, [candidateTokenDetails, heartBeat]);

  useEffect(() => {
    dispatch({ type: examActions.GET_INSTRUCTIONS });
  }, []);

  useEffect(() => {
    if (language) setSelectedlanguage(language);
  }, [language]);

  useEffect(() => {
    if (!candidateTokenDetails?.configuration?.sections) return;
    const totalSectionDurations =
      candidateTokenDetails.configuration.sections.map((section) =>
        dayjs
          .duration({
            hours: Number(section.sectionTime.split(":")[0]),
            minutes: Number(section.sectionTime.split(":")[1]),
          })
          .asMilliseconds()
      );

    const calculateTime = () => {
      const now = dayjs();
      const examStart = dayjs
        .utc(candidateTokenDetails?.configuration?.startTime)
        .subtract(5, "hours")
        .subtract(30, "minutes");

      if (now.isBefore(examStart)) {
        setCurrentSectionIndex(-1);
        return;
      }

      const elapsed = now.diff(examStart);
      let accumulatedTime = 0;

      for (let i = 0; i < totalSectionDurations.length; i++) {
        const sectionDuration = totalSectionDurations[i];

        if (elapsed < accumulatedTime + sectionDuration) {
          if (currentSectionIndex !== i) {
            setCurrentSectionIndex(i);
          }
          return;
        }
        accumulatedTime += sectionDuration;
      }

      setCurrentSectionIndex(
        candidateTokenDetails.configuration.sections.length
      );
    };

    const timer = setInterval(calculateTime, 1000);
    calculateTime();

    return () => clearInterval(timer);
  }, [
    candidateTokenDetails?.configuration?.sections,
    candidateTokenDetails?.configuration?.startTime,
    heartBeat,
    currentSectionIndex,
    currentSrNo,
    imageSize,
    language,
    questionsAndOptions?.questionsList,
  ]);
  
  useEffect(() => {    
    if (isSection) {
      if (!questionsAndOptions?.questionsList) return;
      const obj = questionsAndOptions?.questionsList;
      const arr = Object.entries(obj).map(([key, val]) => ({
        qNo: key,
        ...val,
      }));

      // Find current question's section
      const currentQuestion = arr.find((i) => i?.qNo == currentSrNo);
      const currentSection = currentQuestion?.section;

      // Get questions in current section
      const currentSectionQuestions = arr.filter((i) => i?.section === currentSection);
      const firstqNo = currentSectionQuestions[0]?.qNo;
      const lastqNo = currentSectionQuestions[currentSectionQuestions.length - 1]?.qNo;

      setIsFirstQuestion(currentSrNo === parseInt(firstqNo));
      setIsLastQuestion(currentSrNo === parseInt(lastqNo));
    }
  }, [isSection, currentSrNo, questionsAndOptions?.questionsList]);

  useEffect(() => {
    if (!isSection) {
      const obj = questionsAndOptions?.questionsList;
      if (!obj) return;
      const keys = Object.keys(obj);
      const lastKey = keys[keys.length - 1];
      setIsLastQuestion(currentSrNo === parseInt(lastKey));
    }
  }, [questionsAndOptions?.questionsList, currentSrNo, isSection]);

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    inactivityTimer.current = setTimeout(handleInactivity, apiTimeout);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      clearTimeout(inactivityTimer.current);
      clearTimeout(logoutTimer.current);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("remainingTime", remainingTime.toString());
  }, [remainingTime]);

  useEffect(() => {
    if (now < startTime) return;

    const timer = setInterval(() => {
      setRemainingTime((prev) => {
        if (prev <= 0) {
          moveToNextSection(0);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [activeSection]);

  useEffect(() => {
    const storedTime = Number(localStorage.getItem("remainingTime"));
    if (!isNaN(storedTime) && storedTime > 0) {
      setRemainingTime(storedTime);
    } else if (sections.length > 0) {
      setRemainingTime(parseTime(sections[0]?.sectionTime));
    }
  }, [sections]);

  useEffect(() => {
    const intervalId = setInterval(async () => {
      const currentTimestamp = dayjs();
      const formattedTimestamp = currentTimestamp.format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      );

      const data = {
        ipAddress:
          candidateTokenDetails?.user?.rollNo || candidateData?.candidateName,
        macAddress:
          candidateTokenDetails?.user?.candidateName || candidateData?.rollNo,
        Timestamp: formattedTimestamp,
      };

      const encryptedData = await handleEncodeJson({ encodeJSON: data });
      const now = new Date().toISOString();

      dispatch({
        type: examActions.ACTIVE_PING,
        payload: { data: encryptedData, lastApiCallTime: now },
      });
    }, apiInterval);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      debouncedSaveRef.current?.flush();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  const handleClose = () => {
    setClose(prev => !prev)
  }

  const getSectionIndexByTitle = (sectionTitle) => {
    if (!sectionTitle || !candidateTokenDetails?.configuration?.sections) {
      return -1;
    }
    return candidateTokenDetails.configuration.sections.findIndex(
      (section) => section.sectionTitle === sectionTitle
    );
  };

  const isQuestionInPreviousSection = (targetQNo) => {
    if (!questionsAndOptions?.questionsList || !currentSrNo) return false;
    
    const obj = questionsAndOptions.questionsList;
    const arr = Object.entries(obj).map(([key, val]) => ({
      qNo: parseInt(key),
      ...val,
    }));
    
    // Get current question's section
    const currentQuestion = arr.find((q) => q.qNo === parseInt(currentSrNo));
    const currentSectionTitle = currentQuestion?.section;
    
    // Get target question's section
    const targetQuestion = arr.find((q) => q.qNo === parseInt(targetQNo));
    const targetSectionTitle = targetQuestion?.section;
    
    if (!currentSectionTitle || !targetSectionTitle) return false;
    
    // Get section indices
    const currentSectionIdx = getSectionIndexByTitle(currentSectionTitle);
    const targetSectionIdx = getSectionIndexByTitle(targetSectionTitle);
    
    // If target is in earlier section, it's a previous section
    return targetSectionIdx < currentSectionIdx;
  };

  const getCurrentSectionIndexFromTitle = () => {
    if (!currentSectionTitle || !candidateTokenDetails?.configuration?.sections) {
      return -1;
    }
    return candidateTokenDetails.configuration.sections.findIndex(
      (section) => section.sectionTitle === currentSectionTitle
    );
  };

  // Check if current section timer is active 
  const isSectionTimerActive = () => {
    if (!isFixedTimeMovementRestriction) return false;
    const currentTabIndex = getCurrentSectionIndexFromTitle();
    return currentTabIndex === currentSectionIndex;
  };

  // Helper functions
  const handleVisibilityDialogClose = () => {
    setVisibilityDialogOpen(false);
  }

  const handleVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      // setVisibilityDialogOpen(true);
      setVisibilityDialogOpen(false);
    }
  }

  const getTabValue = (index, sectionTitle) => {
    return JSON.stringify({ index, sectionTitle });
  }

  const currentIndex = useMemo(() => {
    try {
      return JSON.parse(tabValue)?.index ?? 0;
    } catch {
      return 0;
    }
  }, [tabValue]);

  const totalQuestions = questionsAndOptions?.questionsList 
    ? Object.keys(questionsAndOptions.questionsList).length 
    : 0;
  const tabSections = candidateTokenDetails?.configuration?.sections ?? [];

  const updateTabUI = (direction) => {
    const targetIndex = currentIndex + direction;
    const section = tabSections[targetIndex];
    if (section) {
      setTabValue(getTabValue(targetIndex, section.sectionTitle));
      setCurrentSectionTitle(section.sectionTitle);
    }
  };

  const handleTabChange = async (event, newValue) => {
    debouncedSaveRef.current?.flush();
    if (!newValue) return;
    if (!isNoMovementTimeRestriction) return;
    ensureFullscreen();
    const { index, sectionTitle } = JSON.parse(newValue);
    // setTabValue(newValue);
    // setCurrentSectionTitle(sectionTitle);
    if (isFixedTimeMovementRestriction ? currentSectionIndex >= index : true) {
      const obj = questionsAndOptions?.questionsList;
      const arr = Object.entries(obj).map(([key, val]) => ({
        qNo: key,
        ...val,
      }));
      const qNo = arr.filter((i) => i?.section === sectionTitle)[0]["qNo"];
      const formData = {
        imageSize: `${imageSize}`,
        action:
          currentQuestionStatus === "ANSWERED"
            ? "next"
            : currentQuestionStatus === "SKIPPED"
              ? "skip"
              : currentQuestionStatus === "MARKED" ||
                currentQuestionStatus === "ANSWERED_AND_MARKED"
                ? "mark"
                : "next",
        currentSrNo: currentSrNo,
        nextSrNo: qNo,
        selectedAnswer: questionsAndOptions?.questionData?.selectedAnswer || 0,
        language: `${language}`,
      };

      const encodedData = await handleEncodeJson({ encodeJSON: formData });
      const queryParams = {
        SrNo: parseInt(qNo),
        lang: `${language}`,
        img: `${imageSize}`,
      };
      const encryptedParams = EncryptObjectFunction(queryParams);
      dispatch({
        type: examActions.GET_SUBMIT_ANSWER,
        payload: {
          data: encodedData,
          navigate: (path) => navigate(`${path}?qNo=${encryptedParams}`),
          mockMode: projectDetails?.mockMode,
        },
      });
    }
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: `User Changed Tab from ${sectionTitle} to Next`,
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

const handleSelectedValue = useCallback((value) => {
    setSelectedValue(value);
  }, []);

const handleAuditLog = (selectedValue, action, radio) => {
    const registrationNumber = candidateTokenDetails?.user?.id || "";
    const rollNumber = candidateTokenDetails?.user?.rollNo || "";
    const capitalizedAction = action
      ? action.charAt(0).toUpperCase() + action.slice(1)
      : "";

    const data = {
      auditLog: [
        {
          RegistrationNumber: registrationNumber,
          RollNumber: rollNumber,
          Activity:
            action === "clear response"
              ? `User selected in Live Test reset answer for question no ${currentSrNo}`
              : currentStatus === "answered" && action === "mark"
                ? `User selected in Live Test Answered and Mark for Review`
                : action === "next"
                  ? `User selected in Live Test ${capitalizedAction} & viewed Question No ${parseInt(currentSrNo) + 1
                  }`
                  : action === "previous"
                    ? `User selected in Live Test ${capitalizedAction} & viewed Question No ${parseInt(currentSrNo) - 1
                    }`
                    : `User selected in Live Test ${capitalizedAction}`,
          IPaddress: "",
          // Timestamp: `${heartBeat?.data}`,
        },
      ],
    };

    const selectedData = {
      auditLog: [
        {
          RegistrationNumber: registrationNumber,
          RollNumber: rollNumber,
          Activity:
            (action === "mark" && selectedValue && radio) || selectedValue
              ? `User selected in Live Test Option ${selectedValue} for Question No ${currentSrNo}`
              : action === "mark" && !radio
                ? `User selected in Live Test Mark for Review for Question No ${currentSrNo}`
                : null,
          IPaddress: "",
          // Timestamp: `${heartBeat?.data}`,
        },
      ],
    };

    if (selectedValue) {
      dispatch({
        type: examActions.AUDIT_LOG,
        payload: { data: selectedData },
      });
    } else {
      dispatch({
        type: examActions.AUDIT_LOG,
        payload: { data },
      });
    }
  };

const handlePreviousClick = () => {
  if (isFirstQuestion) {
    // updateTabUI(-1);
    handleNext("next", "previous");
    handleAuditLog("", "previous_section");
  } else {
    handleNext("next", "previous");
    handleAuditLog("", "previous");
  }
};

const handleNextClick = () => {
  if (isLastQuestion) {
    // updateTabUI(1);
    handleNext("next");
    handleAuditLog("", "next_section");
  } else {
    handleNext("next");
    handleAuditLog("", "next");
  }
};

  const handleChange = useCallback(async (e) => {
    const status = currentStatusRef.current;
    const action =
      status === "answered_and_marked" || (status === "marked" && e.target.value)
        ? "mark"
        : "next";
    const formData = {
      imageSize: imageSizeRef.current,
      action,
      currentSrNo: currentSrNo,
      nextSrNo: currentSrNo,
      selectedAnswer:
        e.target.value ||
        questionsAndOptions?.questionData?.selectedAnswer ||
        0,
      language: languageRef.current,
    };

    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: examActions.GET_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        mockMode: projectDetails?.mockMode,
        handleSelectedValue: handleSelectedValue,
        radio: true,
      },
    });
    setSelectedValue(e.target.value);
    handleAuditLog(e.target.value, action, true);
  }, [currentSrNo, questionsAndOptions?.questionData?.selectedAnswer, projectDetails?.mockMode, dispatch, handleAuditLog, handleSelectedValue]);


  const debouncedSave = useCallback(
    debounce(async (htmlData, imageSize, currentStatus, currentSrNo, language) => {
      const formData = {
        imageSize: `${imageSize}`,
        action:
          currentStatus === "answered_and_marked" || currentStatus === "marked"
            ? "mark"
            : "next",
        currentSrNo: currentSrNo,
        nextSrNo: currentSrNo,
        descriptiveTypingAnswer: htmlData,
        language: `${language}`,
      };

      const encodedData = await handleEncodeJson({ encodeJSON: formData });

      dispatch({
        type: examActions.GET_SUBMIT_ANSWER,
        payload: {
          data: encodedData,
          mockMode: projectDetails?.mockMode,
          handleSelectedValue: handleSelectedValue,
          radio: true, // prevent saga from clearing the editor after auto-save
        },
      });
    }, 10000),
    []
  );

  useEffect(() => {
    debouncedSaveRef.current = debouncedSave;
  }, [debouncedSave]);
  
  useEffect(() => { currentStatusRef.current = currentStatus; }, [currentStatus]);
  useEffect(() => { imageSizeRef.current = imageSize; }, [imageSize]);
  useEffect(() => { languageRef.current = language; }, [language]);

  useEffect(() => {
    const cached = sessionStorage.getItem(`descriptive_answer_${currentSrNo}`);
    lastValueRef.current = cached || "";
  }, [currentSrNo]);

  const handleTypingChange = useCallback((htmlData) => {
    lastValueRef.current = htmlData;

    sessionStorage.setItem(`descriptive_answer_${currentSrNo}`, htmlData);

    debouncedSaveRef.current(
      htmlData,
      imageSizeRef.current,
      currentStatusRef.current,
      currentSrNo,
      languageRef.current
    );
  }, [currentSrNo]);

  // ── Inline descriptive upload handlers ───────────────────────────────────
  const handleInlineFileSelect = useCallback((srNo, file, validationError) => {
    ensureFullscreen();

    if (validationError) {
      setUploadStates((prev) => ({
        ...prev,
        [srNo]: { file: null, status: null, fileUrl: null, error: validationError },
      }));
      return;
    }

    setUploadStates((prev) => ({
      ...prev,
      [srNo]: { file, status: "uploading", fileUrl: null, error: null },
    }));

    dispatch({
      type: examActions.INLINE_UPLOAD_FILE,
      payload: {
        file,
        srNo,
        onSuccess: async (fileUrl) => {
          setUploadStates((prev) => ({
            ...prev,
            [srNo]: { file, status: "success", fileUrl, error: null },
          }));
          dispatch({ type: examActions.SET_INLINE_UPLOAD_URL, payload: { srNo, fileUrl } });
          const formData = {
            imageSize: `${imageSizeRef.current}`,
            action:
              currentStatusRef.current === "answered_and_marked" ||
              currentStatusRef.current === "marked"
                ? "mark"
                : "next",
            currentSrNo: srNo,
            nextSrNo: srNo,
            descriptiveUploadAnsUrl: fileUrl,
            language: `${languageRef.current}`,
          };
          const encodedData = await handleEncodeJson({ encodeJSON: formData });
          dispatch({
            type: examActions.GET_SUBMIT_ANSWER,
            payload: {
              data: encodedData,
            },
          });
        },
        onError: (msg) => {
          setUploadStates((prev) => ({
            ...prev,
            [srNo]: { file, status: "failed", fileUrl: null, error: msg },
          }));
        },
      },
    });
  }, [dispatch]);

  const handleInlineDelete = useCallback((srNo) => {
    setUploadStates((prev) => ({
      ...prev,
      [srNo]: { ...prev[srNo], status: "deleting" },
    }));
    dispatch({
      type: examActions.INLINE_DELETE_FILE,
      payload: {
        srNo,
        onSuccess: async () => {
          setUploadStates((prev) => {
            const next = { ...prev };
            delete next[srNo];
            return next;
          });
          ensureFullscreen();
          dispatch({ type: examActions.SET_INLINE_UPLOAD_URL, payload: { srNo, fileUrl: null } });
          const formData = {
            imageSize: `${imageSizeRef.current}`,
            action: "save",
            currentSrNo: srNo,
            nextSrNo: srNo,
            descriptiveUploadAnsUrl: "",
            language: `${languageRef.current}`,
          };
          const encodedData = await handleEncodeJson({ encodeJSON: formData });
          dispatch({
            type: examActions.GET_SUBMIT_ANSWER,
            payload: {
              data: encodedData,
            },
          });
        },
        onError: () => {
          setUploadStates((prev) => ({
            ...prev,
            [srNo]: { ...prev[srNo], status: "success" },
          }));
          ensureFullscreen();
        },
      },
    });
  }, [dispatch]);

  const handleInlineView = useCallback((fileUrl) => {
    if (!fileUrl) return;
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: null, method: "FP", data: fileUrl },
    });
  }, [dispatch]);

  const handleInlineRetry = useCallback(
    (srNo) => {
      const current = uploadStates[srNo];
      if (current?.file && !current.file._isExisting) {
        handleInlineFileSelect(srNo, current.file, null);
      }
    },
    [uploadStates, handleInlineFileSelect]
  );

  const handleSubmit = () => {
    debouncedSaveRef.current?.flush();
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: "submit", method: "S", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected in Live Test Submit",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  const handleZoom = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: null, method: "Z", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: `User Zoomed the Question By Clicking Popup`,
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  const handleInstruction = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: null, method: "I", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User Opened Instrucion Popup in Live Test",
      },
      dispatch,
      heartBeat,
    });
  };

  const handleZoomChange = (value) => {
    setZoomLevel(value);
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: `User Zoomed the Question ${value}%`,
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  const handleZoomIn = () => {
    const newValue = zoomLevel + 25;
    handleZoomChange(newValue); // 👈 event-like object pass kar diya
  };

  const handleZoomOut = () => {
    const newValue = zoomLevel > 100 ? zoomLevel - 25 : zoomLevel;
    handleZoomChange(newValue); // 👈 yahan bhi same
  };

  const handleNext = async (action, response) => {
    // Cancel pending debounce — this function sends the latest content itself
    debouncedSaveRef.current?.cancel();
    const latestEditorData = editorInstanceRef.current?.getData();
    const isReset = response === "clearresponse";

    ensureFullscreen();
    if ((action == "next" || action == "previous") &&
        questionsAndOptions?.questionData?.questionType !== "DESCRIPTIVE_TYPING") {
      setSelectedValue("");
    }

    // Clear descriptive state on reset answer
    if (isReset && action === "save") {
      if (questionsAndOptions?.questionData?.questionType === "DESCRIPTIVE_TYPING") {
        lastValueRef.current = "";
        sessionStorage.removeItem(`descriptive_answer_${currentSrNo}`);
      }
    }

    if (action == "mark") {
      setMarkedValue(prev => !prev);
    }
    let qNo;
    if (currentSrNo === questionLength) {
      const obj = questionsAndOptions?.questionsList;
      const arr = Object.entries(obj).map(([key, val]) => ({
        qNo: key,
        ...val,
      }));
      const filtered = arr.filter(
        (val) =>
          val?.status !== "UNANSWERED" &&
          val?.status !== "MARKED" &&
          val?.status !== "ANSWERED"
      );

      if (filtered.length > 0) {
        qNo = filtered[0]["qNo"];
      } else {
        const unanswered = arr.filter((val) => val?.status === "UNANSWERED");
        if (unanswered.length > 0) {
          qNo = unanswered[0]["qNo"];
        } else {
          const marked = arr.filter((val) => val?.status === "MARKED");
          if (marked.length > 0) {
            qNo = marked[0]["qNo"];
          } else {
            qNo = 1;
          }
        }
      }
    }
    const formData = {
      imageSize: `${imageSize}`,
      action: `${currentStatus === "answered_and_marked" &&
        markedValue &&
        action === "mark"
        ? "next"
        : (response === "clearresponse" &&
          action === "save" &&
          currentStatus === "marked") ||
          currentStatus === "answered_and_marked"
          ? "mark"
          : response === "clearresponse" && action === "save"
            ? "save"
            : currentStatus === "marked" && action === "next"
              ? "mark"
              : currentStatus === "answered_and_marked " && action === "next"
                ? "answered_and_marked"
                : currentStatus === "answered_and_marked" &&
                  markedValue &&
                  action === "mark"
                  ? "next"
                  : currentStatus === "answered_and_marked" &&
                    markedValue &&
                    action === "next"
                    ? "mark"
                    : (response === "previous" && currentStatus === "marked") ||
                      currentStatus === "answered_and_marked"
                      ? `mark`
                      : (currentStatus === "marked" ||
                        (currentStatus === "answered_and_marked" && markedValue)
                        ? markedValue
                        : markedValue) ||
                        (action === "next" && response === "answer")
                        ? "next"
                        : action
        }`,
      currentSrNo: questionsAndOptions?.questionData?.srNo,
      nextSrNo:
        action === "next" && response === "answer"
          ? currentSrNo
          : currentSrNo === questionLength &&
            response !== "previous" &&
            action === "next"
            ? parseInt(qNo)
            : response === "previous" && action === "next"
              ? parseInt(currentSrNo) - 1
              : response === "clearresponse" && action === "save"
                ? questionsAndOptions?.questionData?.srNo
                : currentSrNo === questionLength
                  ? currentSrNo
                  : action === "next" || action === "skip"
                    ? parseInt(currentSrNo) + 1
                    : action === "mark"
                      ? questionsAndOptions?.questionData?.srNo
                      : questionsAndOptions?.questionData?.srNo,
      selectedAnswer:
        response === "clearresponse" && action === "save"
          ? 0
          : parseInt(selectedValue) ||
          questionsAndOptions?.questionData?.selectedAnswer ||
          0,

      descriptiveTypingAnswer:
        questionsAndOptions?.questionData?.questionType === "DESCRIPTIVE_TYPING"
          ? isReset ? "" : latestEditorData || lastValueRef.current || ""
          : undefined,
      language: `${language}`,
    };

    const resolvedAction =
      currentStatus === "answered_and_marked" && markedValue && action === "mark"
        ? "next"
        : (response === "clearresponse" && action === "save" && currentStatus === "marked") ||
          currentStatus === "answered_and_marked"
          ? "mark"
          : response === "clearresponse" && action === "save"
            ? "save"
            : currentStatus === "marked" && action === "next"
              ? "mark"
              : currentStatus === "answered_and_marked " && action === "next"
                ? "answered_and_marked"
                : currentStatus === "answered_and_marked" && markedValue && action === "mark"
                  ? "next"
                  : currentStatus === "answered_and_marked" && markedValue && action === "next"
                    ? "mark"
                    : (response === "previous" && currentStatus === "marked") ||
                      currentStatus === "answered_and_marked"
                      ? "mark"
                      : (currentStatus === "marked" ||
                        (currentStatus === "answered_and_marked" && markedValue)
                        ? markedValue
                        : markedValue) || (action === "next" && response === "answer")
                        ? "next"
                        : action;

    setAction(resolvedAction);

    localStorage.setItem("currentAction", resolvedAction);

    const newVisited = new Set([
      ...visitedQuestions,
      String(
        response === "clearresponse" && action === "save"
          ? null
          : (action === "next" && response === "answer") || action === "mark"
            ? questionsAndOptions?.questionData?.srNo
            : action === "next" && response === "previous"
              ? null
              : parseInt(questionsAndOptions?.questionData?.srNo) + 1
      ),
    ]);

    setVisitedQuestions(newVisited);
    sessionStorage.setItem("visitedQuestions", JSON.stringify([...newVisited]));

    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    const queryParams = {
      SrNo: formData?.nextSrNo,
      lang: `${formData?.language}`,
      img: `${formData?.imageSize}`,
    };

    const encryptedParans = EncryptObjectFunction(queryParams);
    dispatch({
      type: examActions.GET_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: (path) => navigate(`${path}?qNo=${encryptedParans}`),
        handleSelectedValue: handleSelectedValue,
        mockMode: projectDetails?.mockMode,
      },
    });
  };


  const handleLanguageChange = async (language, newValue) => {
    debouncedSaveRef.current?.flush();
    setValue(newValue);
    setSelectedlanguage(language);
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected in Live Test Language change",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    let encodedData, queryParams, encryptedParans;
    queryParams = {
      SrNo: currentSrNo,
      lang: language,
      img: imageSize,
    };
    let formData = {
      imageSize: `${imageSize}`,
      action:
        currentStatus === "marked"
          ? "mark"
          : currentStatus === "answered_and_marked"
            ? "mark"
            : "next",
      currentSrNo: currentSrNo,
      nextSrNo: currentSrNo,
      selectedAnswer: questionsAndOptions?.questionData?.selectedAnswer,
      language: `${language}`,
    };
    encodedData = await handleEncodeJson({ encodeJSON: formData });
    encryptedParans = EncryptObjectFunction(queryParams);
    dispatch({
      type: examActions.GET_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: (path) => navigate(`${path}?qNo=${encryptedParans}`),
      },
    });
  };

  const handleInactivity = () => {
    debouncedSaveRef.current?.flush();
    setInactivePopup(true);
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: "inactive", method: "S", data: null },
    });
    logoutTimer.current = setTimeout(() => {
      if (isVenue) {
        Cookies.remove("candidate_details");
        Cookies.remove("candidate_exam_details");
        Cookies.remove("test_engine_token");
        sessionStorage.removeItem("examEnded");
        sessionStorage.removeItem("lastUpdatedIndex");
        navigate(`/login?apiUrl=${apiUrl}`);
      } else {
        Cookies.remove("test_engine_token");
        Cookies.remove("candidate_details");
        Cookies.remove("candidate_exam_details");
        sessionStorage.removeItem("examEnded");
        sessionStorage.removeItem("lastUpdatedIndex");
        navigate(`/${Cookies.get("test_engine_project")}/login`);
      }
    }, idleTimeout);
  };

  const resetTimer = async () => {
    if (inactivePopup) return;

    const now = Date.now();
    if (now - lastApiCallTime.current >= apiTimeout) {
      const currentTimestamp = dayjs();
      const formattedTimestamp = currentTimestamp.format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      );
      const data = {
        ipAddress:
          candidateTokenDetails?.user?.rollNo || candidateData?.candidateName,
        macAddress:
          candidateTokenDetails?.user?.candidateName || candidateData?.rollNo,
        Timestamp: formattedTimestamp,
      };

      const encryptedData = await handleEncodeJson({ encodeJSON: data });
      dispatch({
        type: examActions.ACTIVE_PING,
        payload: { data: encryptedData, lastApiCallTime: now },
      });
      lastApiCallTime.current = now;
    }

    clearTimeout(inactivityTimer.current);
    clearTimeout(logoutTimer.current);
    inactivityTimer.current = setTimeout(handleInactivity, apiTimeout);
  };

  const handleNextSection = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: "nextsection", method: "S", data: null },
    });
  };

  const parseTime = (timeStr) => {
    const [hours, mins] = timeStr.split(":").map(Number);
    return Math.max(0, hours * 3600 + mins * 60);
  };

  const moveToNextSection = (carryOver) => {
    let activeSectionVal = localStorage.getItem("activeSection") || 0;
    if (parseInt(activeSectionVal) < sections.length - 1) {
      let nextSection = parseInt(activeSectionVal) + 1;
      localStorage.setItem("activeSection", nextSection);
      setActiveSection(nextSection);
      setRemainingTime(
        parseTime(sections[nextSection].sectionTime) + carryOver
      );
    }
  };

  const handleManualNext = () => {
    const timeToCarryOver = remainingTime;
    moveToNextSection(timeToCarryOver);
  };

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  const handleToolsMenu = (item, data) => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: item, method: "T", data: data },
    });
    const modifiedItem = item?.charAt(0).toUpperCase() + data.slice(1);
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: `User selected in Live Test ${modifiedItem} Popup`,
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  useEffect(() => {
    const currentImage = questionsAndOptions?.questionData?.question;
    if (currentImage) {
      sessionStorage.setItem("cachedQuestionImage", currentImage);
      setCachedImage(currentImage);
    } else {
      const storedImage = sessionStorage.getItem("cachedQuestionImage");
      if (storedImage) {
        setCachedImage(storedImage);
      }
    }
  }, [questionsAndOptions?.questionData?.question]);

  const questionHeights = isMobile
    ? isIOS
      ? { min: "28vh", scroll: "160px" }   // iOS compact
      : { min: "38vh", scroll: "220px" }   // Android bigger
    : { min: "20vh", scroll: "260px" };    // Desktop

  const answerHeights = isMobile
    ? isIOS
      ? { min: "140px", max: "150px" }     // iOS
      : { min: "170px", max: "220px" }     // Android
    : { min: "130px", max: "180px" };      // Desktop

    const zoomMapDesktop = {
      "100%": 1,
      "125%": 1.5,
      "150%": 2,
      "200%": 2.5,
    };

    const zoomMapMobile = {
      "100%": 2.5,
      "125%": 3,
      "150%": 3.5,
      "200%": 4,
    };   

  const handleZoomOptions = (event) => {
    const value = event.target.value;    
    setSelectedZoomInValue(value);     

    const scale = isMobile ? zoomMapMobile[value] : zoomMapDesktop[value];    
    setZoomScale(scale);
  }

  useEffect(() => {
    if (isAnswerOptionPopupOpen) {
      const defaultValue = "100%";
      setSelectedZoomInValue(defaultValue);    
      const defaultScale = isMobile
        ? zoomMapMobile[defaultValue]
        : zoomMapDesktop[defaultValue];

      setZoomScale(defaultScale);
    }
  }, [isAnswerOptionPopupOpen, isMobile]);

  useEffect(() => {
    if (chatRef.current && clientid && candidateid) {
      chatRef.current.setAttribute('clientid', clientid);
      chatRef.current.setAttribute('candidateid', candidateid);
      chatRef.current.setAttribute('examid', examid);
    }
  }, [clientid, candidateid, examid]);

  return (
    <>
      <Dialog
        open={visibilityDialogOpen}
        maxWidth="xs"
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ color: "error.main" }}>
          ⚠️ Tab Switch Detected
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Switching tabs is not allowed during the exam. Please stay on this page to avoid disciplinary action.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleVisibilityDialogClose} autoFocus variant="contained" color="error">
            Return to Exam
          </Button>
        </DialogActions>
      </Dialog>

      <Grid
        container
        sx={{
          backgroundColor: "#fff",
          height: "100%",
          //  overflow: "hidden",
        }}
      >
        {/* <Box
          sx={{
            display: { xs: "flex", md: "none" }, // 👈 mobile only
            position: "fixed",
            top: "50%",
            right: { xs: "10px", sm: "auto", md: "auto" },
            transform: "translateY(-50%)",
            zIndex: 2000,

            width: { xs: "30px", md: "26px" },
            height: { xs: "30px", md: "26px" },
            borderRadius: "14%",
            backgroundColor: "#3F41D1",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          }}
          onClick={handleClose}
        
        >
          {close ? (
            <MdChevronLeft color="white" size={18} />
          ) : (
            <MdChevronRight color="white" size={18} />
          )}
        </Box> */}

        <Grid
          item
          md={close ? 11.8 : 9.5}
          lg={close ? 11.8 : 9.5}
          sm={close ? 11.8 : 9.5}
          xs={12}
          sx={{
            background: "#fff",
            borderRadius: "16px",
            position: "relative",
            p: '16px 12px 0 12px'
          }}
        >
          {!isMock && (
            <WatermarkBackground rollNo={rollNo} dob={dob} opacity={0.08} />
          )}
          <Grid container style={{
            borderBottom: "1px solid #D4D4D4",
            paddingBottom: "2px",

          }}>
            <Grid item md={7} lg={7} sm={7} xs={12} >
              {isSection && (
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons={false}
                  aria-label="dynamic tabs"
                  TabIndicatorProps={{ style: { display: "none" } }}
                  sx={{
                    width: "100%",

                    // ✅ allow scroll but don’t force scrollbar
                    "& .MuiTabs-scroller": {
                      overflowX: { xs: "auto", md: "hidden" },
                    },

                    "& .MuiTabs-flexContainer": {
                      flexWrap: "nowrap", 
                    },

                    // ✅ hide scrollbar visually
                    "&::-webkit-scrollbar": {
                      height: 0,
                    },

                    "& .MuiTab-root": {
                      textTransform: "none",
                      minWidth: "140px",
                      whiteSpace: "nowrap",
                      padding: "6px 16px 0px 16px",
                      borderRadius: "4px",
                      border: "1px solid #E0E0E0",
                      borderBottom: "none",
                      backgroundColor: "white",
                      marginTop: {xs:"12px",md:"20px"},
                      marginRight: "8px",
                      height: "30px",
                      minHeight: "30px",
                      "&.Mui-selected": {
                        backgroundColor: "rgba(240, 240, 251, 1)",
                        color: "#6366F1",
                        fontWeight: "bold",
                      },
                    },
                  }}
                >

                  {candidateTokenDetails?.configuration?.sections.map(
                    (label, index) => (
                      <Tab
                        sx={{
                          height: "20px",
                          cursor: isNoMovementTimeRestriction
                            ? "cursor"
                            : "default",
                        }}
                        key={index}
                        label={label?.sectionTitle}
                        value={JSON.stringify({
                          index,
                          sectionTitle: label?.sectionTitle,
                        })}
                      />
                    )
                  )}
                </Tabs>
              )}
            </Grid>
            <Grid
              item
              md={5}
              lg={5}
              sm={5}
              xs={12}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                justifyContent: "flex-end",

              }}
            >
              {/* {instructions?.instructions?.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    cursor: "pointer",
                  }}
                  title="Instruction"
                  onClick={handleInstruction}
                >
                  <InfoIcon
                    sx={{
                      height: "20px",
                      width: "auto",
                      margin: 0,
                      padding: 0,
                    }}
                  />
                  <Typography sx={{ fontSize: "14px", pt: 0.5 }}>
                    Instruction
                  </Typography>
                </Box>
              )} */}
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Typography sx={{ fontSize: "14px", pt: 0.5 }}>
                  Language
                </Typography>
                <FormControl fullWidth size="small">
                  <InputLabel></InputLabel>
                  <Select
                    size="small"
                    label=""
                    onChange={(event) =>
                      handleLanguageChange(event.target.value, 0)
                    }
                    sx={{ height: "30px", width: "140px" }}
                    value={language || selectedLanguage}
                  >
                    {candidateTokenDetails?.configuration?.languages.map(
                      (language, index) => (
                        <MenuItem
                          sx={{ textTransform: "capitalize" }}
                          key={index}
                          value={language}
                        >
                          {language.charAt(0).toUpperCase() + language.slice(1)}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Box> */}
              <Box sx={{ display: "flex", alignItems: "center", gap: "16px", justifyContent: "flex-end" }}>
                {pvCharts && (
                  <MdOutlineDataThresholding
                    style={{ height: "24px", width: "auto", cursor: "pointer" }}
                    title="PV Charts"
                    onClick={() => handleToolsMenu("pvCharts", pvCharts)}
                  />
                )}
                {heatTable && (
                  <LuTable
                    style={{ height: "22px", width: "auto", cursor: "pointer" }}
                    title="Heat Table"
                    onClick={() => handleToolsMenu("heatTable", heatTable)}
                  />
                )}
                {helpDocument && (
                  <GoPaperclip
                    style={{ height: "22px", width: "auto", cursor: "pointer" }}
                    title="Help Document"
                    onClick={() => handleToolsMenu("helpDocument", helpDocument)}
                  />
                )}

                {logTables && (
                  <Box
                    component={"img"}
                    src={logImage}
                    alt="img"
                    style={{ height: "22px", width: "auto", cursor: "pointer" }}
                    title="Log Tables"
                    onClick={() => handleToolsMenu("logTable", logTables)}
                  />
                )}
                {isCalculator != "none" && (
                  <CalculatorComponent
                    isMock={isMock}
                    dispatch={dispatch}
                    heartBeat={heartBeat}
                  />
                )}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Typography sx={{ fontSize: "14px", pt: 0.5 }}>Zoom</Typography>
                  {/* <FormControl fullWidth size="small">
                  <InputLabel></InputLabel>
                  <Select
                    size="small"
                    label=""
                    sx={{ height: "30px", width: "100px" }}
                    defaultValue={100}
                    value={zoomLevel}
                    onChange={handleZoomChange}
                  >
                    <MenuItem value={100}>100%</MenuItem>
                    <MenuItem value={200}>200%</MenuItem>
                    <MenuItem value={400}>300%</MenuItem>
                    <MenuItem value={500}>400%</MenuItem>
                  </Select>
                </FormControl> */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={zoomLevel <= 100}
                      onClick={handleZoomOut}
                      sx={{ minWidth: "30px", borderRadius: "50%", color: "black", border: "1px solid black" }}
                    >
                      A-
                    </Button>

                    <Button
                      variant="outlined"
                      size="small"
                      disabled={zoomLevel >= 200}
                      onClick={handleZoomIn}
                      sx={{ minWidth: "30px", borderRadius: "50%", color: "black", border: "1px solid black", }}
                    >
                      A+
                    </Button>
                    <Box
                      onClick={handleClose}
                      sx={{
                        display: "flex", // 👈 desktop only
                        alignItems: "center",
                        justifyContent: "center",

                        width: "26px",
                        height: "26px",
                        borderRadius: "14px",
                        backgroundColor: "#3F41D1",
                        cursor: "pointer",

                        // 👇 KEY FIX
                        position: { xs: "fixed", md: "static" },
                        right: { xs: "5px", md: "auto" },
                        top: { xs: "32px", md: "auto" },
                        transform: { xs: "translateY(-50%)", md: "none" },

                        zIndex: 20,
                      }}
                    >
                      {close ? (
                        <MdChevronLeft size={18} color="#fff" />
                      ) : (
                        <MdChevronRight size={18} color="#fff" />
                      )}
                    </Box>

                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>


          <Grid
            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" , }}
            // pb={1}
            pt={!isSection ? 1 : 0.5}
          >
            <Box>
              <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "rgba(63, 65, 209, 1)" }}>
                Question{" "}
                {currentSrNo || questionsAndOptions?.questionData?.srNo} of{" "}
                {questionLength}:
              </Typography>
            </Box>

            <Box>
              {/* <Box sx={{ display: "flex", gap: "4px" }}>
                <FormControlLabel
                  sx={{ margin: 0, padding: 0, color: "rgba(63, 65, 209, 1)" }}
                  control={
                    <Checkbox
                      color="success"
                      sx={{
                        margin: 0,
                        padding: 0,
                        color: "rgba(63, 65, 209, 1)",
                      }}
                      onChange={() => {
                        handleAuditLog("", "mark");
                        handleNext("mark");
                      }}
                      checked={markedValue}
                    />
                  }
                  label={
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "rgba(63, 65, 209, 1)",
                        pt: 0.5,
                      }}
                    >
                      Mark Review
                    </Typography>
                  }
                />
              </Box> */}
              <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
                {(isMock ||
                  (submitButtonDisplayMinutes !== 0 &&
                    timeLeft.totalMinutes < submitButtonDisplayMinutes &&
                    !isAutologout)) && (
                    <Button
                      size="small"
                      variant="contained"
                      style={{
                        fontWeight: "bold",
                        padding: { xs: "2px", md: "4px" },
                        width: "78px",
                        backgroundColor: "#E598AC",
                        color: "#000",
                        borderRadius: "78px",
                        "&:hover": {
                          backgroundColor: "#E598AC",
                        },
                        cursor: "default",
                      }}
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  )}

              </Box>
            </Box>
          </Grid>
          <Box
            p={1}
            sx={{
              minHeight: questionHeights.min,
              backgroundColor: "white",
              border: "1px solid #E0E0E0",
              borderRadius: "8px",
              marginBottom: "0.3rem"
            }}
          >
            <Grid
              ref={questionScrollRef}
              sx={{
                height: questionHeights.scroll,
                paddingRight: "8px",
                border: "1px solid black",
                borderRadius: "8px",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#e0e0e0",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "blue",
                  borderRadius: "10px",
                  border: "2px solid #e0e0e0",
                  height: "10px",
                  paddingBottom: "12px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "darkblue",
                },
              }}
            >
              <Grid
                container
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  position: "relative",
                }}
              >
                <Grid item md={11} lg={11} sm={11} xs={12}>
                  <Box
                    component={"img"}
                    src={cachedImage}
                    alt={"question"}
                    style={{
                      width: isMobile
                        ? `${zoomLevel}%`      // mobile zoomed
                        : zoomLevel === 100
                          ? "90%"
                          : `${zoomLevel}%`,
                      height: "auto",
                      transition: "width 0.3s ease",
                    }}
                  />
                </Grid>
                <Grid item md={0.4} p={1} sx={{ right: { xs: 45, md: 335, lg: 335 } }}>
                  <BsArrowsFullscreen
                    size={20}
                    style={{ cursor: "pointer" }}
                    onClick={handleZoom}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Box pt={1}>
              <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                Answer
              </Typography>
            </Box>
            <AnswerSection
              type={questionsAndOptions?.questionData?.questionType}
              key={`${currentSrNo}`}
              currentSrNo={currentSrNo}
              selectedValue={selectedValue}
              handleChange={handleChange}
              handleTypingChange={handleTypingChange}
              options={questionsAndOptions?.questionData?.options}
              isMock={isMock}
              answerScrollRef={answerScrollRef}
              editorInstanceRef={editorInstanceRef}
              uploadState={uploadStates[currentSrNo]}
              allowUpload={questionsAndOptions?.questionData?.allowUpload}
              uploadType={questionsAndOptions?.questionData?.uploadType}
              onInlineFileSelect={handleInlineFileSelect}
              onInlineDelete={handleInlineDelete}
              onInlineView={handleInlineView}
              onInlineRetry={handleInlineRetry}
              disabled={timeUp}
            />
          </Box>
          {/*//////////////// -- For Showing numbers or alphabet in option sections---- /////////////////////////////////////////////// */}
          {/* {questionsAndOptions?.questionData?.options?.map((q, i) => (
                <>
                  <Box
                    style={{ display: "flex", alignItems: "center", fontSize: "14px" }}
                    key={i}
                  >
                    <Radio
                      checked={String(selectedValue) === String(i + 1)}
                      onChange={(e) => handleChange(e)}
                      value={String(i + 1)}
                      name="questionOptions"
                      sx={{
                        '& .MuiSvgIcon-root': {
                          fontSize: 18,
                        }
                      }}
                    />
                    <Typography sx={{ fontWeight: "bold", mr: 0 }}>
                      {i + 1}.
                    </Typography> */}
          {/* If option is text, show as Typography. If image, show as img. */}
          {/* {typeof q === "string" && (q.startsWith("http") || q.startsWith("data:image"))
                      ? <img
                          src={q}
                          style={{ height: "auto", width: isMock ? "85%" : "65%" }}
                          alt={`option-${i}`}
                        />
                      : <Typography>{q}</Typography>
                    }
                  </Box> */}
          {/* <Divider sx={{ mr: 4, p: "2px" }} /> */}
          {/* </>
              ))}
            </Box>
          </Box> */}
          <Grid
            // mt={close ? 1.3 : 2.8}
            // mb={close ? 0 : -4}
            // sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}

            mt={{ xs: 2, md: close ? 1.3 : 2.8 }}
            mb={{ xs: 1, md: close ? 0 : -4 }}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "center", md: "normal" },
              justifyContent: "space-between",
              gap: "10px",
              position: 'relative'
            }}
          >
            <Box sx={{
              display: "flex",
              justifyContent: { xs: "space-between", md: "flex-start" },
              alignItems: "center",
              gap: {
                xs: 0,
                sm: "10px"
              },
              flexWrap: {
                xs: 'nowrap',
                sm: 'wrap'
              },
              width: "100%",
            }}>
              {/* <FormControlLabel
                sx={{ margin: 0, padding: 0, color: "rgba(63, 65, 209, 1)" }}
                control={
                  <Checkbox
                    color="success"
                    sx={{
                      margin: 0,
                      padding: 0,
                      color: "rgba(63, 65, 209, 1)",
                    }}
                    onChange={() => {
                      handleAuditLog("", "mark");
                      handleNext("mark");
                    }}
                    checked={markedValue}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "rgba(63, 65, 209, 1)",
                      pt: 0.5,
                    }}
                  >
                    Mark Review
                  </Typography>
                }
              /> */}
              {/* <Box sx={{
                display: (candidateTokenDetails?.configuration?.sections?.length ?? 0) <= 1 ? 'none' : 'flex',
                justifyContent: {
                  xs: 'center',
                  md: 'end'
                },
                width: '100%',
                mt: {
                  xs: 6,
                  lg: 0
                },
                whiteSpace: 'nowrap',
                position: 'absolute',
                top: '50px'
              }}>
                <SecondaryButton color="rgba(63, 65, 209, 1)" border="1px solid rgba(63, 65, 209, 1)" width="250px"              
                  onClick={() => handlePreviousTabChange()}
                  disabled={isFirstTab}
                >
                  Previous Section
                </SecondaryButton>

                <Box sx={{
                  display: 'flex',
                  justifyContent: 'end',
                  width: '100%',                  
                }}>
                  <SecondaryButton color="rgba(63, 65, 209, 1)" border="1px solid rgba(63, 65, 209, 1)"
                    onClick={() => handleNextTabChange()}
                    disabled={isLastTab}
                  >
                    Next Section
                  </SecondaryButton>
                </Box>
            </Box> */}
              {!isQuestionNavigationForwardOnly && currentSrNo !== 1 && (
                <SecondaryButton
                  color={"rgba(63, 65, 209, 1)"}
                  border="1px solid rgba(63, 65, 209, 1)"
                  onClick={handlePreviousClick}
                  disabled={
                    timeUp || 
                    isQuestionNavigationForwardOnly || 
                    currentSrNo === 1 ||
                    (isFirstQuestion && isSectionTimerActive()) ||                    
                    (isFixedTimeMovementRestriction && 
                    isQuestionInPreviousSection(parseInt(currentSrNo) - 1))
                  }
                >
                  {isFirstQuestion ? "Previous Section" : "Previous"}
                </SecondaryButton>
              )}

              {questionsAndOptions?.questionData?.questionType != "DESCRIPTIVE_UPLOAD" && (

                <SecondaryButton
                  color={"rgba(63, 65, 209, 1)"}
                  border="1px solid rgba(63, 65, 209, 1)"
                  onClick={() => {
                    handleNext("save", "clearresponse");
                    handleAuditLog("", "clear response");
                  }}
                  // disabled={markedValue}
                  disabled={!selectedValue}
                >
                  Reset Answer
                </SecondaryButton>)}
              {/* {isLastQuestion &&
                (isMovementRestrictionWithIncrementalTime ||
                  isMovementRestrictionWithNoTimeRestriction) &&
                !isSectionLastQuestion && (
                  <SecondaryButton
                    color="rgba(63, 65, 209, 1)"
                    border="1px solid rgba(63, 65, 209, 1)"
                    onClick={handleNextSection}
                  >
                    Next Section
                  </SecondaryButton>
                )} */}

              {(!isLastQuestion || isSectionLastQuestion) &&
                !isNoMovementTimeRestriction && (
                  <SecondaryButton
                    color={"rgba(63, 65, 209, 1)"}
                    border="1px solid rgba(63, 65, 209, 1)"
                    onClick={() => {
                      handleNext("next");
                      handleAuditLog("", "next");
                    }}
                    disabled={isLastQuestion}
                  >
                    Next
                  </SecondaryButton>
                )}

              {isNoMovementTimeRestriction && currentSrNo !== totalQuestions && (
                <SecondaryButton
                  color={"rgba(63, 65, 209, 1)"}
                  border="1px solid rgba(63, 65, 209, 1)"
                  onClick={handleNextClick}
                  disabled={isLastQuestion && isSectionTimerActive()}
                >
                  {isLastQuestion ? "Next Section" : "Next"}
                </SecondaryButton>
              )}
            </Box>
            {/* <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
              {(isMock ||
                (submitButtonDisplayMinutes !== 0 &&
                  timeLeft.totalMinutes < submitButtonDisplayMinutes &&
                  !isAutologout)) && (
                  <Button
                    size="small"
                    variant="contained"
                    style={{
                      fontWeight: "bold",
                      padding: "4px",
                      width: "78px",
                      backgroundColor: "#E598AC",
                      color: "#000",
                      borderRadius: "78px",
                      "&:hover": {
                        backgroundColor: "#E598AC",
                      },
                      cursor: "default",
                    }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                )}
           
            </Box> */}

            <Box sx={{
              display: 'flex',
              justifyContent: {
                xs: 'center',
                md: 'end'
              },
              width: '100%',
              mt: {
                xs: 1,
                sm: 0
              },
              gap: 1
            }}>
              {questionsAndOptions?.questionData?.questionType === "MCQ" && (
              <SecondaryButton color="rgba(63, 65, 209, 1)" border="1px solid rgba(63, 65, 209, 1)"
              onClick={() => setIsAnswerOptionPopupOpen(true)}
              >
                Option Zoom
              </SecondaryButton> )}
              <Box sx={{ display: "flex", gap: { xs: "4px", md: "1px" }, flexWrap: "nowrap", }}>
                <FormControlLabel
                  sx={{ margin: 0, padding: 0, color: "rgba(63, 65, 209, 1)", width: "min-content" }}
                  control={
                    <Checkbox
                      color="success"
                      sx={{
                        margin: 0,
                        padding: 0,
                        color: "rgba(63, 65, 209, 1)",
                      }}
                      onChange={() => {
                        handleAuditLog("", "mark");
                        handleNext("mark");
                      }}
                      checked={markedValue}
                    />
                  }
                  label={
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "rgba(63, 65, 209, 1)",
                        pt: 0.5,
                        whiteSpace: "nowrap",      // 🔥 prevent breaking
                        wordBreak: "keep-all",     // 🔥 do NOT break words
                        overflowWrap: "normal",
                      }}
                    >
                      Mark Review
                    </Typography>
                  }
                />
              </Box>
            </Box>



          </Grid>
        </Grid>

        <Grid
          ref={togglePanelRef}
          lg={close ? 0.1 : 2.5}
          md={close ? 0.1 : 2.5}
          sm={close ? 0.1 : 2.5}

          sx={{
            display: {
              xs: close ? "none" : "block",
              sm: "block",
              md: "block",
            },
            position: { xs: "fixed", sm: "relative" },
            right: 0,
            top: 0,
            height: { xs: "100vh", sm: "auto" },
            width: { xs: "85%", sm: "auto" },
            zIndex: 10,
            backgroundColor: "#f0f0fb",
          }}
        >


          {!close && (<Grid
            item
            pt={2}
            pl={2}
            pb={0}
            pr={2}
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: "86vh",
              backgroundColor: "#f0f0fb",
              marginTop: { xs: "0px", sm: "0px", md: "0px", lg: "0px" },
              // transition: "transform 0.3s ease-in-out",
              // transform: {
              //   xs: close ? "translateX(100%)" : "translateX(0)",
              //   sm: "none",
              // },
              // borderTop:"2px solid #e0e0e0"

            }}
          >



            <Box sx={{ flexGrow: 1 }}>
              <QuestionNumberComponent
                questionsAndOptions={questionsAndOptions}
                handleAuditLog={handleAuditLog}
                setNextQuestion={setNextQuestion}
                candidateTokenDetails={candidateTokenDetails}
                timeLeft={timeLeft}
                currentSectionTitle={currentSectionTitle}
                setCurrentSectionTitle={setCurrentSectionTitle}
                remainingTimeOfIncrementalTime={remainingTime}
                formatTimeTimeOfIncrementalTime={formatTime}
                onQuestionSelect={() => {
                  debouncedSaveRef.current?.flush();
                  if (window.innerWidth < 768) {
                    setClose(true);
                  }
                }}
                lastAnswerRef={lastValueRef}
                flushDebouncedSave={() => debouncedSaveRef.current?.flush()}
                currentQuestionType={questionsAndOptions?.questionData?.questionType}
              />
            </Box>

            <Grid p={1} sx={{ bottom: 0, width: "100%" }}>
              {/* {(isMock ||
              (submitButtonDisplayMinutes !== 0 &&
                timeLeft.totalMinutes < submitButtonDisplayMinutes &&
                !isAutologout)) && (
                <PrimaryButton
                  width="96%"
                  color="#000"
                  borderRadius="138px"
                  height="38px"
                  onClick={handleSubmit}
                >
                  Submit
                </PrimaryButton>
              )} */}
            </Grid>
          </Grid>)}
        </Grid>
        {/* <Grid
          item
          md={2.5}
          p={2}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "86vh",
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <QuestionNumberComponent
              questionsAndOptions={questionsAndOptions}
              handleAuditLog={handleAuditLog}
              setNextQuestion={setNextQuestion}
              candidateTokenDetails={candidateTokenDetails}
              timeLeft={timeLeft}
              currentSectionTitle={currentSectionTitle}
              setCurrentSectionTitle={setCurrentSectionTitle}
              remainingTimeOfIncrementalTime={remainingTime}
              formatTimeTimeOfIncrementalTime={formatTime}
            />
          </Box>

          <Grid p={1}  sx={{ bottom: 0,marginTop:"-50px", width: "100%" }}>
            {(isMock ||
              (submitButtonDisplayMinutes !== 0 &&
                timeLeft.totalMinutes < submitButtonDisplayMinutes &&
                !isAutologout)) && (
                <PrimaryButton
                  width="96%"
                  color="#000"
                  borderRadius="138px"
                  height="38px"
                  onClick={handleSubmit}
                >
                  Submit
                </PrimaryButton>
              )}
          </Grid>
        </Grid> */}
      </Grid>
      <SubmitModal
        type={"submit"}
        encryptedParams={encryptedParamsConverted}
        heartBeat={heartBeat}
      />
      <SubmitModal type={"inactive"} lastApiCallTime={lastApiCallTime} />
      <SubmitModal
        type={"nextsection"}
        handleNext={handleNext}
        isMovementRestrictionWithNoTimeRestriction={
          isMovementRestrictionWithNoTimeRestriction
        }
        currentSectionTitle={currentSectionTitle}
      />
      <ZoomModal img={questionsAndOptions?.questionData?.question} />
      <FilePreviewModal />
      <InstructionModal
        filteredInstructions={filteredInstructions}
        value={value}
      />
      <ToolBarModal />
      {
        (proctoringEnabled && proctoringType && proctoringEngine) && (
          <>
            <rpt-exam-screen
              ref={examRef}
              proctoring-type={proctoringType}
              proctoring-engine={proctoringEngine}
              violations={JSON.stringify(violations)}
              is-violation-auto-submit-enabled={isViolationAutoSubmitEnabled}
              violation-threshold-count={violationThresholdCount}
              logout-url={Cookies.get('test_engine_project')} // to redirect base url
              asset-base-url="angular-components/angular-app/"
            />

            {proctoringType === PROCTORING_TYPE.LIVE && (
              <rpt-chat-modal
                ref= {chatRef}
                clientid={clientid}        //  ADD
                candidateid={candidateid}  //  ADD
                examid={examid}            //  ADD
                isOpen={true}
                showFloatingButton={true}
                // onChatOpened={() => console.log("Chat opened")}
                // onChatClosed={() => console.log("Chat closed")}
                // onSendMessage={(message) => console.log("Message:", message)}
              />
            )}
          </>
        )
      }

      <Dialog
        sx={{
          '& .MuiDialog-paper' : {
            width: '100%',
            maxWidth: '100%',
            margin: {
              xs: 2,
              sm: 4
            }
          }
        }}
        open={isAnswerOptionPopupOpen}
        onClose={() => setIsAnswerOptionPopupOpen(false)}
        aria-labelledby="alert-option-zoom-in-dialog"
        aria-describedby="alert-option-dialog"
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: {
          xs: 'space-between',          
        }, gap: 6}} id="alert-option-dialog">          
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', whiteSpace: 'nowrap', gap: {
              xs: 1,
              sm: 3
            } }}>
            <Typography component="span" sx={{ fontSize: {
              xs: '14px',
              sm: '20px'
            }, fontWeight: 600 }}>
              Option Zoom
            </Typography>
            <FormControl fullWidth size="small">
              <InputLabel></InputLabel>
              <Select              
                labelId="demo-zoom-option-select-label"
                id="demo-option-select"
                size="small"
                label=""
                onChange={handleZoomOptions}
                sx={{ height: '30px', width: {
                  xs: '120px',
                  sm: '140px'
                } }}
                value={selectedZoomInValue}
              >
                <MenuItem value={'100%'}>100%</MenuItem>
                <MenuItem value={'125%'}>125%</MenuItem>
                <MenuItem value={'150%'}>150%</MenuItem>
                <MenuItem value={'200%'}>200%</MenuItem>
              </Select>
            </FormControl>            
          </Box>
          <IconButton
            sx={{ p: 0 }}
            aria-label="close"
            onClick={() => setIsAnswerOptionPopupOpen(false)}              
          >
            <IoMdCloseCircleOutline />
          </IconButton>       
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-option-dialog">
            {questionsAndOptions?.questionData?.options?.map((q, i) => (
              <>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "28px 1fr",
                    alignItems: "center",
                    columnGap: "8px",
                    width: "100%",
                    mb: "2px",
                  }}
                  key={i}
                >
                  <Radio
                    checked={String(selectedValue) === String(i + 1)}
                    onChange={(e) => handleChange(e)}
                    value={String(i + 1)}
                    name="questionOptions"
                    sx={{
                      mb: '16px',
                      '& .MuiSvgIcon-root': {
                        fontSize: 16,
                      }
                    }}
                  />
                  <Box sx={{ width: "100%" }}>
                    {isMock && (
                      <Typography
                        sx={{ textWrap: "nowrap", cursor: "pointer" }}
                        onClick={() =>
                          handleChange({ target: { value: String(i + 1) } })
                        }
                      >{`Option ${String.fromCharCode(65 + i)}`}</Typography>
                    )}

                    <img
                      src={q}
                      alt={`option-${i}`}
                      style={{
                        width: `${zoomScale * 100}%`,
                        display: "block",
                        transformOrigin: "top left",
                        transition: "transform 0.2s ease",
                        marginBottom: "20px",
                      }}
                    />
                  </Box>
                </Box>
              </>
            ))}
          </DialogContentText>
        </DialogContent>        
      </Dialog>

      {showBackWarning && (
        <PreventBackNavigationWarningModal
          {...{showBackWarning, setShowBackWarning}}          
        />
      )}
    </>
  );


}
